import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "babel-polyfill";
import "@/assets/icon-font/iconfont.css";

import ElementUI from "element-ui";
import {MessageBox} from "element-ui";
import './assets/scss/element-variables.scss'
//element
Vue.use(ElementUI);
Vue.prototype.$elementConfirm = MessageBox.confirm;


import {DDDInit} from "@/ddd";
import {ComponentInit} from "@/components";
import {DirectiveInit} from "@/directives";
import {FilterInit} from "@/filters";

//工具类
DDDInit(Vue);
//组件
ComponentInit(Vue);
//指令
DirectiveInit(Vue);
FilterInit(Vue);

// import moment from 'moment'

Vue.prototype.isMobile = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i) !== null;
Vue.config.productionTip = false;
Vue.prototype.getConfigJson = function () {
    Vue.prototype.http$
        .get("/fileUrl.json")
        .then(result => {
            Vue.prototype.filePre$ = result; //设置成Vue的全局属性
            new Vue({
                router,
                render: (h) => h(App),
                store
            }).$mount("#app");
        })
};

Vue.prototype.getConfigJson(); //调用声明的全局方法
